import React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import styled from 'styled-components';

import AppState from '@webapp/store/state';
import { ProductSample } from '@webapp/store/merch/state';
import { UpdateMerchProductSample } from '@webapp/store/merch/action-creators';

import { MerchCatalogItemColor } from '@services/merch/types/api/merch-catalog-item';
import { getImagePositionAndMaskWithProductId } from '@webapp/utils/merch/imageAndMaskWithProductId';
import Flex from '@components/layout/flex';
interface ProductColorProps {
  products: MerchCatalogItemColor[] | undefined;
}

interface ProductColorStateProps {
  productSampleOrder?: ProductSample | undefined | null;
  imageSource?: string;
}

interface ProductColorMapDispatchProps {
  updateSampleOrder: (sampleOrder: ProductSample) => void;
}

const mapStateToProps = (state: AppState) => {
  const createProduct = state.merch.active?.product?.id;
  const EditProduct = state.merch.active?.editProduct?.printify[0].itemId;
  const imageSource = getImagePositionAndMaskWithProductId(
    (EditProduct as number) || (createProduct as number)
  );
  const productSampleOrder = state.merch.active?.productSample;
  return {
    productSampleOrder,
    imageSource: imageSource[0],
  };
};
const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateSampleOrder: (sampleOrder: ProductSample) =>
    dispatch(new UpdateMerchProductSample(sampleOrder)),
});

const ProductColor = ({
  products,
  productSampleOrder,
  updateSampleOrder,
  imageSource,
}: ProductColorProps &
  ProductColorStateProps &
  ProductColorMapDispatchProps) => {
  const updateReceiveSampleOrder = (color: string, selected: boolean) => {
    let existingColors = productSampleOrder?.productColors || [];

    if (selected) {
      const existing = existingColors.findIndex((obj) => obj === color);
      existingColors.splice(existing, 1);
    } else if (existingColors.length === 0) {
      existingColors.push(color);
    } else {
      existingColors = [color];
    }
    updateSampleOrder({ ...productSampleOrder, productColors: existingColors });
  };

  React.useEffect(() => {
    if (products?.length === 1 && updateReceiveSampleOrder) {
      const productLabel = products[0].label;
      const colors = productSampleOrder?.productColors;
      const selected = !!(
        colors && colors.find((color) => color === productLabel)
      );
      updateReceiveSampleOrder(productLabel, selected);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // TODO: DEVTEAM-1005 - The user must be able to select/deselect multiple colors.
  return (
    <Flex
      justifyContent="flex-start"
      alignItems="center"
      gap={5}
      flexWrap="wrap"
    >
      {products
        ?.filter((product) => product?.color)
        .map((product) => {
          const colors = productSampleOrder?.productColors;
          const selected = !!(
            colors && colors.find((color) => color === product.label)
          );

          return (
            <ProductWrapper
              className={selected ? 'selected' : ''}
              key={product.id}
              onClick={() => updateReceiveSampleOrder(product.label, selected)}
            >
              <ProductColorImage
                className={selected ? 'selected' : ''}
                src={imageSource}
                color={product.color}
              />
            </ProductWrapper>
          );
        })}
    </Flex>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductColor);

interface ProductColorImageProps {
  color?: string;
}

const ProductColorImage = styled.img<ProductColorImageProps>`
  cursor: pointer;
  width: 60px;
  height: 64px;
  border-radius: 4px;
  background-color: ${({ color }) => color};

  &.selected {
    border-radius: 4px 4px 0 0;
  }
`;

const ProductWrapper = styled.div`
  display: grid;
  border-radius: 4px;
  border-bottom: 4px solid transparent;
  transition: border-bottom
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &.selected {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;
